import request from './request'

export function listStockLedger(data) {
  return request.post('/inventory/stock-ledgers/list', data)
}
